import React, { useState, useEffect, useRef } from "react";
import "./Crm.css";
import { Button, Grid, Skeleton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import SaveIcon from "@mui/icons-material/Save";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import TextfieldCust from "./Components/TextfieldCust";
import DropdownCust from "./Components/DropdownCust";
import { ListItemService } from "../../../service/manage/crm/crm_list_item.service";
import CrmSearchModal from "./Components/CrmSearchModal";
import { sweetStatusAlert } from "../../../components/common/SweetAlert";
import { CrmMainService } from "../../../service/manage/crm/crm_main.service";
import ChecklistDropdown from "./Components/ChecklistDropdown";
import CrmUpdateSearchModel from "./Components/CrmUpdateSearchModel";
import CrmDeleteSearchModel from "./Components/CrmDeleteSearchModel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FieldListService } from "../../../service/manage/crm/crm_field_list.service";
import ReactSelect from "react-select";
import CrmSkeletonSpinner from "./Components/CrmSkeletonSpinner";
import CRMRelay from "./CrmRelays";
import Tooltip from "@mui/material/Tooltip";
import ToggleButtonCust from "./Components/ToggleButtonCust";
import TimeZoneHandler from "../../../handlers/TimeZoneHandler";
import BookmarksContext, { BookmarksProvider } from "./context/BookmarkContext";

const CrmFilter = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUpdateOpen, setIsUpdateModelOpen] = useState(false);
  const [isDeleteOpen, setDeleteOpen] = useState(false);
  const [filters, setFilters] = useState([
    {
      condition: "",
      blockText: "",
      operation: "",
      searchValue: "",
      comparisonType: "1",
      searchValueOptions: null,
      isCalendar: false,
      users: [],
      isUserLoading: false,
      userSearchTerm: "",
      selectedUser: null,
      isRowLoading: false,
    },
  ]);

  const [blockTextOptions, setBlockTextOptions] = useState([]);
  const [operationOptions, setOperationOptions] = useState([]);
  const [comparisonOptions, setComparisonOptions] = useState([]);
  const [conditionOptions, setConditionOptions] = useState([]);
  const [savedFilters, setSavedFilters] = useState([]);
  const [loadingStates, setLoadingStates] = useState({
    blockText: false,
    operation: false,
    condition: false,
    comparison: false,
  });
  const [savedFilterLoading, setSavedFilterLoading] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [sortColumn, setSortColumn] = useState("user_code");
  const [sortDirection, setSortDirection] = useState("desc");
  const [intermediateFilters, setIntermediateFilters] = useState([]);
  const latestRequestRef = useRef(0);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchFilters, setSearchFilters] = useState([]);
  const [searchResetTrigger, setSearchResetTrigger] = useState(0);

  const [loading, setLoading] = useState(false);
  const [privileges, setPrivileges] = useState({
    canView: props.state?.privilege_view === 1,
    canEdit: props.state?.privilege_edit === 1,
    canAdd: props.state?.privilege_add === 1,
    canDelete: props.state?.privilege_delete === 1,
  });

  const canManageFilters = privileges.canView && privileges.canEdit;
  // const canCreateFilters = canManageFilters && privileges.canAdd;
  const canDeleteFilters = canManageFilters && privileges.canDelete;

  useEffect(() => {
    const fetchDropdownOptions = async () => {
      try {
        setLoadingStates({
          blockText: true,
          operation: true,
          condition: true,
          comparison: true,
        });

        const [listItemResponse] = await Promise.all([
          ListItemService.getAllListItem(),
        ]);

        const { operations, compersions, conditions, block_text } =
          listItemResponse?.data;
        setOperationOptions(operations);
        setComparisonOptions(compersions);
        setConditionOptions(conditions);
        setBlockTextOptions(block_text);

        setLoadingStates({
          blockText: false,
          operation: false,
          condition: false,
          comparison: false,
        });
      } catch (error) {
        console.error("Error fetching dropdown options:", error);

        setLoadingStates({
          blockText: false,
          operation: false,
          condition: false,
          comparison: false,
        });
      }
    };

    const fetchData = async () => {
      await fetchDropdownOptions();
      await fetchSavedFilters();
    };

    fetchData();
  }, []);

  const fetchSavedFilters = async () => {
    try {
      setSavedFilterLoading(true);
      const response = await CrmMainService.getAllSavedFilters(
        props.state.mid,
        props.state.lg_user_id,
        props.state.lg_user_table_id,
        props.state.lg_user_id,
        props.state.lg_user_table_id
      );
  
      if (privileges.canView && !privileges.canEdit) {
        const filteredData = response.data.filter(item => item.status === 2);
        setSavedFilters(filteredData);
      } else {

        setSavedFilters(response.data);
      }
  
      setSavedFilterLoading(false);
    } catch (error) {
      setSavedFilterLoading(false);
      console.error("Error fetching saved filters:", error);
    }
  };
  

  const getCompletedFilters = () => {
    return filters.filter((filter, index) => isRowComplete(filter, index));
  };

  const handleOpenModal = () => {
    const completedFilters = getCompletedFilters();

    if (intermediateFilters.length === 0) {
      if (completedFilters.length === 0) {
        sweetStatusAlert(
          "Warning",
          "Please fill at least one complete row before saving the filter.",
          "info"
        );
        return;
      }
      setFilters(completedFilters);
    }

    setIsModalOpen(true);
  };

  const handleUpdateOpenModal = () => {
    const completedFilters = getCompletedFilters();
    setFilters(completedFilters);
    setIsUpdateModelOpen(true);
  };

  const handleUpdateCloseModal = () => {
    setIsUpdateModelOpen(false);
  };

  const handleDeleteOpenModal = () => {
    setDeleteOpen(true);
  };

  const handleDeleteCloseModal = () => {
    setDeleteOpen(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleFilterChange = async (index, key, value) => {
    if (!privileges.canEdit) return;
    const initialUpdatedFilters = [...filters];
    initialUpdatedFilters[index].isRowLoading = true;
    setFilters(initialUpdatedFilters);

    try {
      const updatedFilters = [...filters];

      if (key === "blockText") {
        updatedFilters[index].searchValueOptions = null;
        updatedFilters[index].searchValue = "";

        if (
          value === "22" ||
          value === "28" ||
          value === "27" ||
          value === "26" ||
          value === "21"
        ) {
          updatedFilters[index].comparisonType = 3;
          updatedFilters[index].isCalendar = true;
        } else if (value === "25" || value === "29") {
          updatedFilters[index].operation = 1;
          updatedFilters[index].comparisonType = 1;
          updatedFilters[index].isCalendar = false;

          try {
            const response = await ListItemService.getListItByID(value);
            const listItems = response.data;

            updatedFilters[index].searchValueOptions = listItems;
            updatedFilters[index].searchValue = "";
          } catch (error) {
            console.error("Error fetching list items:", error);
          }
        } else if (value === "24" || value === "30") {
          updatedFilters[index].isCalendar = false;
          updatedFilters[index].comparisonType = 1;
          await fetchAllUsers(index);
        } else {
          updatedFilters[index].isCalendar = false;
        }
      } else if (key === "searchValue") {
        updatedFilters[index].searchValue = value;
      }

      updatedFilters[index][key] = value;

      updatedFilters[index].isRowLoading = false;
      setFilters(updatedFilters);
    } catch (error) {
      const errorUpdatedFilters = [...filters];
      errorUpdatedFilters[index].isRowLoading = false;
      setFilters(errorUpdatedFilters);
      console.error("Error in handleFilterChange:", error);
    }
  };

  const fetchAllUsers = async (index) => {
    const updatedFilters = [...filters];
    updatedFilters[index].isUserLoading = true;
    setFilters(updatedFilters);

    try {
      const response = await FieldListService.getAllCrmUsers(
        props.state.mid,
        props.state.form_list_id,
        props.state.lg_user_id,
        props.state.lg_user_table_id,
        5000,
        0,
        sortColumn,
        sortDirection,
        updatedFilters[index].userSearchTerm
      );
      updatedFilters[index].users = response?.data?.users || [];
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      updatedFilters[index].isUserLoading = false;
      setFilters(updatedFilters);
    }
  };

  const handleUserSearch = (index, inputValue) => {
    if (!privileges.canEdit) return;
    const updatedFilters = [...filters];
    updatedFilters[index].userSearchTerm = inputValue;
    setFilters(updatedFilters);
  };

  const handleUserSelect = (index, selectedOption) => {
    if (!privileges.canEdit) return;
    const updatedFilters = [...filters];

    updatedFilters[index].selectedUser = selectedOption;

    // Format the searchValue as "<user_id>|<table_id>"
    if (selectedOption) {
      updatedFilters[
        index
      ].searchValue = `${selectedOption.value}|${selectedOption.user_table_id}`;
    } else {
      updatedFilters[index].searchValue = "";
    }

    setFilters(updatedFilters);
  };

  const handleDateChange = (date, index) => {
    const updatedFilters = [...filters];
    // const formattedDate = date.toISOString().replace("T", " ").replace("Z", "");

    const formattedDate = TimeZoneHandler.formatDateToYYYYMMDDHHmm(date);

    updatedFilters[index].searchValue = formattedDate;
    setFilters(updatedFilters);
  };

  const handleAddFilter = () => {
    setFilters((prevFilters) => [
      ...prevFilters,
      {
        condition: "1",
        blockText: "",
        operation: "",
        searchValue: "",
        comparisonType: "1",
        searchValueOptions: null,
        isCalendar: false,
        users: [],
        isUserLoading: false,
        userSearchTerm: "",
        selectedUser: null,
        isRowLoading: false,
      },
    ]);
  };

  const handleDeleteFilter = (index) => {
    const updatedFilters = filters.filter((_, i) => i !== index);
    setFilters(updatedFilters);
  };

  const handleClearAll = () => {
    setFilters([
      {
        condition: "",
        blockText: "",
        operation: "",
        searchValue: "",
        comparisonType: "1",
        searchValueOptions: null,
        isCalendar: false,
        users: [],
        isUserLoading: false,
        userSearchTerm: "",
        selectedUser: null,
        isRowLoading: false,
      },
    ]);
    setSelectedFilters([]);
  };
  

  const handleSearchFilter = async (sortArray = "", show_matched = 0) => {
    try {
      setSearchLoading(true);

      let searchArray = [];

      if (selectedFilters.length > 1) {
        searchArray = selectedFilters.map((filter) => ({
          ID: filter.id,
        }));
      } else {
        searchArray = filters.map((filter, index) => {
          const obj = {
            FLD: Number(filter.blockText),
            37: Number(filter.operation),
            VAL: filter.searchValue,
            39: Number(filter.comparisonType),
            ID: null,
          };

          if (index !== 0) {
            obj[38] = Number(filter.condition);
          }

          return obj;
        });
      }

      const filterObject = {
        node_mid: props?.state?.mid,
        search_array: searchArray,
        sort_array: sortArray,
        show_matched: show_matched,
        user_id: props?.state?.lg_user_id,
        user_table_id: props?.state?.lg_user_table_id,
      };
      

      const response = await CrmMainService.crm_search_execution(filterObject);

      if (response?.success) {
        setSearchFilters(response?.data);
      } else {
        sweetStatusAlert(
          "Failed",
          "Search execution was unsuccessful.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error executing search:", error);
      sweetStatusAlert(
        "Failed",
        "An error occurred while executing the search.",
        "error"
      );
    } finally {
      setSearchLoading(false);
    }
  };

  const handleParentSearch = async () => {
    setSearchResetTrigger((prev) => prev + 1);
    await handleSearchFilter();
  };

  const isRowComplete = (filter, index) => {
    const isComplete =
      index === 0
        ? filter.blockText && filter.operation && filter.searchValue
        : // filter.comparisonType
          filter.condition &&
          filter.blockText &&
          filter.operation &&
          filter.searchValue &&
          filter.comparisonType;

    return isComplete;
  };

  const resetFilters = () => {
    setFilters([
      {
        condition: "",
        blockText: "",
        operation: "",
        searchValue: "",
        comparisonType: "1",
        searchValueOptions: null,
        isCalendar: false,
        users: [],
        isUserLoading: false,
        userSearchTerm: "",
        selectedUser: null,
        isRowLoading: false,
      },
    ]);
    setSelectedFilters([]);
  };

  const transformSelectedFilterToFilters = async (
    selectedFilter,
    requestId
  ) => {
    setLoading(true);

    const transformedFilters = await Promise.all(
      selectedFilter.str.map(async (filterItem) => {
        const filter = {
          condition: String(filterItem.field_38),
          blockText: String(filterItem.FLD),
          operation: String(filterItem.field_37),
          searchValue: String(filterItem.VAL),
          comparisonType: String(filterItem.field_39),
          isCalendar: false,
          searchValueOptions: null,
          users: [],
          isUserLoading: false,
          userSearchTerm: "",
          selectedUser: null,
        };

        if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(filterItem.VAL)) {
          filter.isCalendar = true;
        } else if (["25", "29"].includes(String(filterItem.FLD))) {
          try {
            const response = await ListItemService.getListItByID(
              filterItem.FLD
            );
            if (requestId !== latestRequestRef.current) return null;

            const listItems = response.data;
            filter.searchValueOptions = listItems;
            filter.searchValue = listItems.some(
              (item) => item.display_order == filterItem.VAL
            )
              ? filterItem.VAL
              : "";
          } catch (error) {
            console.error("Error fetching list items:", error);
          }
        } else if (["24", "30"].includes(String(filterItem.FLD))) {
          filter.isUserLoading = true;
          try {
            const [userId, userTableId] = filterItem.VAL.split("|");

            const response = await FieldListService.getAllCrmUsers(
              props.state.mid,
              props.state.form_list_id,
              props.state.lg_user_id,
              props.state.lg_user_table_id,
              5000,
              0,
              sortColumn,
              sortDirection,
              ""
            );

            if (requestId !== latestRequestRef.current) return null; // Prevent stale updates

            filter.users = response?.data?.users || [];

            if (userId && userTableId) {
              const selectedUser = filter.users.find(
                (user) =>
                  String(user.user_id) === String(userId) &&
                  String(user.user_table_id) === String(userTableId)
              );

              if (selectedUser) {
                filter.selectedUser = {
                  value: selectedUser.user_id,
                  label: selectedUser.data_concat,
                  user_table_id: selectedUser.user_table_id,
                  ...selectedUser,
                };
              }
            }
          } catch (error) {
            console.error("Error fetching users:", error);
          } finally {
            filter.isUserLoading = false;
            // setLoading(false);
          }
        }

        return filter;
      })
    );

    if (requestId === latestRequestRef.current) {
      setLoading(false);
    }

    return transformedFilters.filter(Boolean);
  };

  const handleSelectFilters = async (selectedOptions) => {
    setSelectedFilters(selectedOptions);
    const currentRequestId = ++latestRequestRef.current;

    // Check if selectedOptions[0]?.str[0] is an empty object
    const isEmptyObject =
      selectedOptions[0]?.str[0] &&
      Object.keys(selectedOptions[0].str[0]).length === 0;

    // If no filters are selected, reset state
    if (selectedOptions.length === 0) {
      setFilters([
        {
          condition: "",
          blockText: "",
          operation: "",
          searchValue: "",
          comparisonType: "1",
          searchValueOptions: null,
          isCalendar: false,
          users: [],
          isUserLoading: false,
          userSearchTerm: "",
          selectedUser: null,
          isRowLoading: false,
        },
      ]);
      setIntermediateFilters([]);
      setLoading(false); // Ensure loading is false when nothing is selected
      return;
    }

    setLoading(true);

    try {
      if (selectedOptions.length === 1 && !isEmptyObject) {
        const selectedFilter = selectedOptions[0];
        const newFilters = await transformSelectedFilterToFilters(
          selectedFilter,
          currentRequestId
        );

        if (currentRequestId === latestRequestRef.current) {
          setFilters(newFilters);
        }
      } else {
        const newIntermediateFilters = selectedOptions.map((option) => ({
          id: option.id,
        }));

        setIntermediateFilters(newIntermediateFilters);
      }
    } catch (error) {
      console.error("Error processing filters:", error);
    } finally {
      if (currentRequestId === latestRequestRef.current) {
        setLoading(false); // Ensure loading is false after processing
      }
    }
  };

  useEffect(() => {
    if (searchResetTrigger > 0) {
      handleSearchFilter();
    }
  }, [searchResetTrigger]);
  
  const handleFilterForLinkedBlocks = async (blocks) => {
    resetFilters();
  
    const filterOptions = blocks.map((block, index) => ({
      condition: index > 0 ? "2" : "",
      blockText: "14",
      operation: "1",
      searchValue: String(block.block_id),
      comparisonType: "1",
      isCalendar: false,
      searchValueOptions: null,
      users: [],
      isUserLoading: false,
      userSearchTerm: "",
      selectedUser: null,
    }));
  
    setFilters(filterOptions);
  
    // Increment the trigger to notify useEffect
    setSearchResetTrigger((prev) => prev + 1);
  };

  return (
    <BookmarksProvider>
      <div>
        <div className="crm-filter-container">
          <Grid
            container
            spacing={2}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <div className="TotalContainer">
              <Grid item xs={12} md={8}>
                <div className="filterSec1">
                  {/* Show filters only if one or no item is selected */}
                  {loading ? (
                    <CrmSkeletonSpinner />
                  ) : (
                    !(
                      selectedFilters.length === 1 &&
                      selectedFilters[0]?.str[0] &&
                      Object.keys(selectedFilters[0].str[0]).length === 0
                    ) &&
                    selectedFilters.length <= 1 &&
                    (privileges.canView || privileges.canEdit) && // Only show if user has view or edit privileges
                    filters.map((filter, index) => (
                      <div style={{ marginBottom: "8px" }} key={index}>
                        {filter.isRowLoading ? (
                          <Grid
                            container
                            spacing={2}
                            className="gridContainer"
                            style={{ marginBottom: "8px" }}
                          >
                            <Grid item xs={6} md={2}>
                              <Skeleton
                                variant="rectangular"
                                width="100%"
                                height={40}
                              />
                            </Grid>
                            <Grid item xs={6} md={2}>
                              <Skeleton
                                variant="rectangular"
                                width="100%"
                                height={40}
                              />
                            </Grid>
                            <Grid item xs={5} md={2}>
                              <Skeleton
                                variant="rectangular"
                                width="100%"
                                height={40}
                              />
                            </Grid>
                            <Grid item xs={1}>
                              <Skeleton
                                variant="rectangular"
                                width="100%"
                                height={40}
                              />
                            </Grid>
                          </Grid>
                        ) : (
                          // <CrmSkeletonSpinner />
                          <Grid container spacing={2} className="gridContainer">
                            <Grid item xs={2} md="auto">
                              {loadingStates.comparison ? (
                                <div className="text-center p-2">
                                  Loading...
                                </div>
                              ) : (
                                <div className="relative">
                                  <Tooltip
                                    placement="top"
                                    title={` ${(() => {
                                      switch (filter.comparisonType) {
                                        case "1":
                                          return "Text Type";
                                        case "2":
                                          return "Numeric Type";
                                        case "3":
                                          return "Date Type";
                                        default:
                                          return "Text Type";
                                      }
                                    })()}`}
                                    arrow
                                  >
                                    <div
                                      title={(() => {
                                        switch (filter.comparisonType) {
                                          case "1":
                                            return "Text Type";
                                          case "2":
                                            return "Numeric Type";
                                          case "3":
                                            return "Date Type";
                                          default:
                                            return "Text Type";
                                        }
                                      })()}
                                    >
                                      <button
                                        className={`w-12 h-12 dataTypeClick duration-300 ${
                                          filter.blockText === "22" ||
                                          filter.blockText === "28" ||
                                          filter.blockText === "27" ||
                                          filter.blockText === "25" ||
                                          filter.blockText === "29" ||
                                          filter.blockText === "21" ||
                                          filter.blockText === "26"
                                            ? "opacity-50"
                                            : "hover:shadow-lg"
                                        }`}
                                        style={{
                                          backgroundColor: (() => {
                                            switch (filter.comparisonType) {
                                              case "1":
                                                return "#e1d1e3"; // Purple for Text
                                              case "2":
                                                return "#cad1da"; // Gray for Numeric
                                              case "3":
                                                return "#d9e4e7"; // Light blue for Date
                                              default:
                                                return "#e1d1e3"; // Default to Text
                                            }
                                          })(),
                                          border: (() => {
                                            switch (filter.comparisonType) {
                                              case "1":
                                                return "2px solid #baa4bc";
                                              case "2":
                                                return "2px solid #a0a7b0";
                                              case "3":
                                                return "2px solid #a3c4ca";
                                              default:
                                                return "2px solid #baa4bc";
                                            }
                                          })(),
                                          cursor:
                                            filter.blockText === "22" ||
                                            filter.blockText === "28" ||
                                            filter.blockText === "27" ||
                                            filter.blockText === "25" ||
                                            filter.blockText === "29" ||
                                            filter.blockText === "21" ||
                                            filter.blockText === "26"
                                              ? "not-allowed"
                                              : "pointer",
                                        }}
                                        onClick={() => {
                                          if (
                                            filter.blockText === "22" ||
                                            filter.blockText === "28" ||
                                            filter.blockText === "27" ||
                                            filter.blockText === "25" ||
                                            filter.blockText === "29" ||
                                            filter.blockText === "21" ||
                                            filter.blockText === "26"
                                          ) {
                                            return;
                                          }

                                          let nextValue;
                                          switch (filter.comparisonType) {
                                            case "1":
                                              nextValue = "2";
                                              break;
                                            case "2":
                                              nextValue = "3";
                                              break;
                                            case "3":
                                              nextValue = "1";
                                              break;
                                            default:
                                              nextValue = "1";
                                              break;
                                          }

                                          handleFilterChange(
                                            index,
                                            "comparisonType",
                                            nextValue
                                          );
                                        }}
                                        title={(() => {
                                          switch (filter.comparisonType) {
                                            case "1":
                                              return "Click to change to Numeric";
                                            case "2":
                                              return "Click to change to Date";
                                            case "3":
                                              return "Click to change to Text";
                                            default:
                                              return "Click to change type";
                                          }
                                        })()}
                                        disabled={
                                          !privileges.canEdit ||
                                          filter.blockText === "22" ||
                                          filter.blockText === "28" ||
                                          filter.blockText === "27" ||
                                          filter.blockText === "25" ||
                                          filter.blockText === "29" ||
                                          filter.blockText === "21" ||
                                          filter.blockText === "26"
                                        }
                                      >
                                        {(() => {
                                          switch (filter.comparisonType) {
                                            case "1":
                                              return "T";
                                            case "2":
                                              return "N";
                                            case "3":
                                              return "D";
                                            default:
                                              return "T";
                                          }
                                        })()}
                                      </button>
                                    </div>
                                  </Tooltip>
                                </div>
                              )}
                            </Grid>
                            {index === 0 ? (
                              <>
                                {/* <Grid item xs={6} md={1}></Grid> */}
                                <div style={{ minWidth: "64px" }}></div>
                                <Grid item xs={6} md={2}>
                                  <DropdownCust
                                    placeholder="Block Text"
                                    value={filter.blockText}
                                    onChange={(e) =>
                                      handleFilterChange(
                                        index,
                                        "blockText",
                                        e.target.value
                                      )
                                    }
                                    disabled={!privileges.canEdit}
                                  >
                                    {loadingStates.blockText ? (
                                      <option>Loading...</option>
                                    ) : (
                                      blockTextOptions.map((option) => (
                                        <option
                                          key={option.field_id}
                                          value={option.field_id}
                                        >
                                          {option.title}
                                        </option>
                                      ))
                                    )}
                                  </DropdownCust>
                                </Grid>
                                <Grid item xs={6} md="auto">
                                  <DropdownCust
                                    placeholder="Operation"
                                    value={filter.operation}
                                    onChange={(e) =>
                                      handleFilterChange(
                                        index,
                                        "operation",
                                        e.target.value
                                      )
                                    }
                                    disabled={
                                      !privileges.canEdit ||
                                      filter.blockText === "25" ||
                                      filter.blockText === "29"
                                    }
                                  >
                                    {loadingStates.operation ? (
                                      <option>Loading...</option>
                                    ) : (
                                      operationOptions.map((option) => (
                                        <option
                                          key={option.display_order}
                                          value={option.display_order}
                                        >
                                          {option.list_item}
                                        </option>
                                      ))
                                    )}
                                  </DropdownCust>
                                </Grid>
                                <Grid item xs={5} md={3}>
                                  {filter.isCalendar ? (
                                    <DatePicker
                                      selected={
                                        filter.searchValue
                                          ? new Date(filter.searchValue)
                                          : null
                                      }
                                      onChange={(date) =>
                                        handleDateChange(date, index)
                                      }
                                      disabled={!privileges.canEdit}
                                      dateFormat="yyyy-MM-dd HH:mm"
                                      showTimeSelect
                                      timeFormat="HH:mm"
                                      timeIntervals={1}
                                      placeholderText="Select Date"
                                      className="date-picker-custom"
                                    />
                                  ) : filter.searchValueOptions ? (
                                    <DropdownCust
                                      placeholder="Search Value"
                                      value={filter.searchValue}
                                      onChange={(e) =>
                                        handleFilterChange(
                                          index,
                                          "searchValue",
                                          e.target.value
                                        )
                                      }
                                      disabled={!privileges.canEdit}
                                    >
                                      {filter.searchValueOptions.map(
                                        (option) => (
                                          <option
                                            key={option.display_order}
                                            value={option.display_order}
                                          >
                                            {option.list_item}
                                          </option>
                                        )
                                      )}
                                    </DropdownCust>
                                  ) : filter.blockText === "24" ||
                                    filter.blockText === "30" ? (
                                    <ReactSelect
                                      options={filter.users?.map((user) => ({
                                        value: user.user_id,
                                        label: `${user.data_concat}`,
                                        user_table_id: user.user_table_id,
                                        ...user,
                                      }))}
                                      value={filter.selectedUser}
                                      isLoading={filter.isUserLoading}
                                      onChange={(selectedOption) =>
                                        handleUserSelect(index, selectedOption)
                                      }
                                      onInputChange={(inputValue) =>
                                        handleUserSearch(index, inputValue)
                                      }
                                      onMenuClose={() => {
                                        if (filter.userSearchTerm) {
                                          const updatedFilters = [...filters];
                                          updatedFilters[index].userSearchTerm =
                                            "";
                                          setFilters(updatedFilters);
                                          fetchAllUsers(index);
                                        }
                                      }}
                                      isDisabled={!privileges.canEdit}
                                    />
                                  ) : (
                                    <TextfieldCust
                                      placeholder="Search Value"
                                      value={filter.searchValue}
                                      onChange={(e) =>
                                        handleFilterChange(
                                          index,
                                          "searchValue",
                                          e.target.value
                                        )
                                      }
                                      disabled={!privileges.canEdit}
                                    />
                                  )}
                                </Grid>
                              </>
                            ) : (
                              <>
                                {/* <Grid item xs={3} md={2}>
                            <DropdownCust
                              placeholder="Condition"
                              value={filter.condition}
                              onChange={(e) =>
                                handleFilterChange(
                                  index,
                                  "condition",
                                  e.target.value
                                )
                              }
                            >
                              {loadingStates.condition ? (
                                <option>Loading...</option>
                              ) : (
                                conditionOptions.map((option) => (
                                  <option
                                    key={option.display_order}
                                    value={option.display_order}
                                  >
                                    {option.list_item}
                                  </option>
                                ))
                              )}
                            </DropdownCust>
                          </Grid> */}
                                {/* <Grid item xs={3} md={1}> */}
                                <div style={{ minWidth: "64px" }}>
                                  <ToggleButtonCust
                                    value={filter.condition}
                                    onChange={(e) =>
                                      handleFilterChange(
                                        index,
                                        "condition",
                                        e.target.value
                                      )
                                    }
                                    index={index}
                                    disabled={!privileges.canEdit}
                                  />
                                </div>
                                {/* </Grid> */}
                                <Grid item xs={6} md={2}>
                                  <DropdownCust
                                    placeholder="Block Text"
                                    value={filter.blockText}
                                    onChange={(e) =>
                                      handleFilterChange(
                                        index,
                                        "blockText",
                                        e.target.value
                                      )
                                    }
                                    disabled={!privileges.canEdit}
                                  >
                                    {loadingStates.blockText ? (
                                      <option>Loading...</option>
                                    ) : (
                                      blockTextOptions.map((option) => (
                                        <option
                                          key={option.field_id}
                                          value={option.field_id}
                                        >
                                          {option.title}
                                        </option>
                                      ))
                                    )}
                                  </DropdownCust>
                                </Grid>
                                <Grid item xs={6} md="auto">
                                  <DropdownCust
                                    placeholder="Operation"
                                    value={filter.operation}
                                    onChange={(e) =>
                                      handleFilterChange(
                                        index,
                                        "operation",
                                        e.target.value
                                      )
                                    }
                                    disabled={
                                      !privileges.canEdit ||
                                      filter.blockText === "25" ||
                                      filter.blockText === "29"
                                    }
                                  >
                                    {loadingStates.operation ? (
                                      <option>Loading...</option>
                                    ) : (
                                      operationOptions.map((option) => (
                                        <option
                                          key={option.display_order}
                                          value={option.display_order}
                                        >
                                          {option.list_item}
                                        </option>
                                      ))
                                    )}
                                  </DropdownCust>
                                </Grid>
                                <Grid item xs={5} md={3}>
                                  {filter.isCalendar ? (
                                    <DatePicker
                                      selected={
                                        filter.searchValue
                                          ? new Date(filter.searchValue)
                                          : null
                                      }
                                      onChange={(date) =>
                                        handleDateChange(date, index)
                                      }
                                      dateFormat="yyyy-MM-dd HH:mm"
                                      showTimeSelect
                                      timeFormat="HH:mm"
                                      timeIntervals={1}
                                      placeholderText="Select Date"
                                      className="date-picker-custom"
                                      disabled={!privileges.canEdit}
                                    />
                                  ) : filter.searchValueOptions ? (
                                    <DropdownCust
                                      placeholder="Search Value"
                                      value={filter.searchValue}
                                      onChange={(e) =>
                                        handleFilterChange(
                                          index,
                                          "searchValue",
                                          e.target.value
                                        )
                                      }
                                      disabled={!privileges.canEdit}
                                    >
                                      {filter.searchValueOptions.map(
                                        (option) => (
                                          <option
                                            key={option.display_order}
                                            value={option.display_order}
                                          >
                                            {option.list_item}
                                          </option>
                                        )
                                      )}
                                    </DropdownCust>
                                  ) : filter.blockText === "24" ||
                                    filter.blockText === "30" ? (
                                    <ReactSelect
                                      options={filter.users?.map((user) => ({
                                        value: user.user_id,
                                        label: `${user.data_concat}`,
                                        user_table_id: user.user_table_id,
                                        ...user,
                                      }))}
                                      value={filter.selectedUser}
                                      isLoading={filter.isUserLoading}
                                      onChange={(selectedOption) =>
                                        handleUserSelect(index, selectedOption)
                                      }
                                      onInputChange={(inputValue) =>
                                        handleUserSearch(index, inputValue)
                                      }
                                      onMenuClose={() => {
                                        if (filter.userSearchTerm) {
                                          const updatedFilters = [...filters];
                                          updatedFilters[index].userSearchTerm =
                                            "";
                                          setFilters(updatedFilters);
                                          fetchAllUsers(index);
                                        }
                                      }}
                                      isDisabled={!privileges.canEdit}
                                    />
                                  ) : (
                                    <TextfieldCust
                                      placeholder="Search Value"
                                      value={filter.searchValue}
                                      onChange={(e) =>
                                        handleFilterChange(
                                          index,
                                          "searchValue",
                                          e.target.value
                                        )
                                      }
                                      disabled={!privileges.canEdit}
                                    />
                                  )}
                                </Grid>
                              </>
                            )}

                            {filters.length > 1 && canDeleteFilters && (
                              <Grid item xs="auto">
                                <button
                                  className="FilterSecondaryIcons deleteIcon"
                                  onClick={() => handleDeleteFilter(index)}
                                >
                                  <DeleteForeverIcon />
                                </button>
                              </Grid>
                            )}
                            {/*Need to come canCreateFilters */}
                            {index === filters.length - 1 &&
                              isRowComplete(filter, index) &&
                              canManageFilters && (
                                <Grid item xs={1}>
                                  <button
                                    className="FilterSecondaryIcons plusIcon"
                                    onClick={handleAddFilter}
                                  >
                                    <AddIcon />
                                  </button>
                                </Grid>
                              )}
                          </Grid>
                        )}
                      </div>
                    ))
                  )}

                  {/* Show summaries if more than one item is selected */}
                  {(selectedFilters.length > 1 ||
                    (selectedFilters.length === 1 &&
                      selectedFilters[0]?.str[0] &&
                      Object.keys(selectedFilters[0].str[0]).length === 0)) &&
                    !loading &&
                    privileges.canView && (
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                          <div className="summary">
                            {selectedFilters.map((filter, index) => (
                              <div key={index}>
                                Summary - {filter.str_display}
                              </div>
                            ))}
                          </div>
                        </Grid>
                      </Grid>
                    )}

                  {/* Show buttons only if one or no item is selected */}
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <div className="selectingfilt">
                        {/*Need to come canCreateFilters */}
                        {(selectedFilters.length === 0 ||
                          selectedFilters.length > 1) &&
                          canManageFilters && (
                            <button
                              className="filtbtn fil-save"
                              onClick={handleOpenModal}
                              disabled={loading}
                            >
                              <SaveIcon /> Save Filter
                            </button>
                          )}

                        {/* Always show "Search" button */}
                        {privileges.canView && (
                          <button
                            className="FilterSearchIcon"
                            onClick={handleParentSearch}
                            disabled={loading}
                          >
                            <SearchIcon sx={{ mr: 1 }} /> Search
                          </button>
                        )}
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </Grid>

              <Grid item xs={12} md={3}>
                <div className="filterSec2">
                  {/* <TextfieldCust placeholder="Free Search" /> */}
                  {privileges.canView && (
                    <ChecklistDropdown
                      options={savedFilters}
                      selectedOptions={selectedFilters}
                      onSelect={handleSelectFilters}
                      placeholder="Use Saved Filter"
                      isLoading={savedFilterLoading}
                    />
                  )}
                  <div className="selectingfilt" style={{ marginTop: "8px" }}>
                    {/* Show "Update Saved Filter" and "Delete Saved Filter" buttons only when one filter is selected */}
                    {selectedFilters.length === 1 && canManageFilters && (
                      <>
                        {privileges.canEdit && (
                          <button
                            className="filtbtn fil-save"
                            onClick={handleUpdateOpenModal}
                            disabled={loading}
                          >
                            <SaveIcon sx={{ mr: 1 }} /> Update Saved Filter
                          </button>
                        )}
                        {canDeleteFilters && (
                          <button
                            className="filtbtn del"
                            onClick={handleDeleteOpenModal}
                            disabled={loading}
                          >
                            <DeleteForeverIcon sx={{ mr: 1 }} /> Delete Saved
                            Filter
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </Grid>
            </div>
            <Grid item xs={12} md={1}>
              {/* Always show "Clear All" button */}
              {privileges.canEdit && (
                <Grid item xs={12} md={1}>
                  <button
                    className="filtbtn clrall"
                    onClick={handleClearAll}
                    disabled={loading}
                  >
                    <DeleteForeverIcon sx={{ mb: 1, fontSize: "20px" }} />
                    <br />
                    Clear Filter Section
                  </button>
                </Grid>
              )}
            </Grid>
          </Grid>

          <CrmSearchModal
            isOpen={isModalOpen}
            onClose={handleCloseModal}
            state={props.state}
            filters={filters}
            resetFilters={resetFilters}
            fetchSavedFilters={fetchSavedFilters}
            intermediateFilters={intermediateFilters}
          />

          <CrmUpdateSearchModel
            isOpen={isUpdateOpen}
            onClose={handleUpdateCloseModal}
            onOpen={handleUpdateOpenModal}
            state={props.state}
            filters={filters}
            selectedFilters={selectedFilters}
            fetchSavedFilters={fetchSavedFilters}
            resetFilters={resetFilters}
          />
          <CrmDeleteSearchModel
            isOpen={isDeleteOpen}
            onClose={handleDeleteCloseModal}
            onOpen={handleDeleteOpenModal}
            state={props.state}
            selectedFilters={selectedFilters}
            fetchSavedFilters={fetchSavedFilters}
            resetFilters={resetFilters}
          />
        </div>
        <CRMRelay
          searchFilters={searchFilters}
          searchLoading={searchLoading}
          state={props}
          handleSearchFilter={handleSearchFilter}
          searchResetTrigger={searchResetTrigger}
          handleFilterForLinkedBlocks={handleFilterForLinkedBlocks}
        />
      </div>
    </BookmarksProvider>
  );
};

export default CrmFilter;
